<section class="w-full">
  <split-header-section
    title="Relatório de Funcionários"
  ></split-header-section>

  <split-filter-menu
    (filterEvent)="addFilterOptions($event)"
  ></split-filter-menu>

  <form [formGroup]="form" class="w-full mt-5" [style.padding-left]="'16.002px'" [style.padding-right]="'16.002px'">
    <div class="grid mt-5">
      <div class="col">
        <div class="bg-white p-5 border-round-2xl box-shadow">
          <div class="header mb-6 flex justify-content-between">
            <span class="title"> Agendamentos por funcionários </span>
            <div class="flex align-items-center">
              <button
                (click)="removeFilterUnidade()"
                class="clear_filter mr-4"
                *ngIf="applyFilterUnidade"
              >
              Limpar filtro
              </button>
              <div [ngClass]="applyFilterUnidade ? 'filter-applied' : 'filter'">
                <p-menu
                  #menuUnidade
                  [model]="filtroUnidade"
                  [popup]="true"
                ></p-menu>
                <button
                  pButton
                  type="button"
                  (click)="menuUnidade.toggle($event)"
                  label="Unidade"
                ></button>
              </div>
            </div>
          </div>

          <div class="w-full">
            <div class="header flex -mb-3">
              <div style="width: 10%" class="p-3"></div>
              <div style="width: 40%" class="text-left">Funcionário</div>
              <div style="width: 20%">Unidade</div>
              <div style="width: 15%">Retornos</div>
              <div style="width: 15%">Pagos</div>
            </div>

            <div
              class="flex align-items-center border-round-xl mt-3"
              *ngFor="
                let funcionario of form.value.agendamento_funcionario;
                let i = index
              "
              [ngClass]="
                i % 2 === 0 ? 'linha_impar_laranja' : 'linha_par_laranja'
              "
            >
              <div style="width: 10%" class="text-center p-3 ranking_text">
                {{ funcionario.posicao_ranking }}
              </div>
              <div style="width: 40%" class="name_text flex align-items-center">
                <img
                  class="border-circle h-2rem mr-3"
                  src="assets/avatar/Avatar.png"
                  alt="foto do funcionário"
                />
                {{ funcionario.nome_funcionario }}
              </div>
              <div style="width: 20%" class="unit_name_text">
                <div class="add_ellipsis text-center m-auto">
                  {{ funcionario.nome_unidade }}
                </div>
              </div>
              <div style="width: 15%" class="text-center normal_text">
                {{ funcionario.retornos }}
              </div>
              <div style="width: 15%" class="text-center normal_text">
                {{ funcionario.pagos }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="bg-white p-5 border-round-2xl box-shadow">
          <div class="header mb-6 flex">
            <span class="title"> Avaliações enviadas antes de 3 horas </span>
          </div>

          <div class="w-full">
            <div class="header flex -mb-3">
              <div style="width: 10%" class="p-3"></div>
              <div style="width: 60%" class="text-left">Funcionário</div>
              <div style="width: 30%">Porcentagem</div>
            </div>

            <div
              class="flex align-items-center border-round-xl mt-3"
              *ngFor="
                let funcionario of form.value.avaliacoes_antes_de_tres_horas;
                let i = index
              "
              [ngClass]="i % 2 === 0 ? 'linha_impar_azul' : 'linha_par_azul'"
            >
              <div style="width: 10%" class="text-center p-3 ranking_text">
                {{ funcionario.posicao_ranking }}
              </div>
              <div style="width: 60%" class="name_text flex align-items-center">
                <img
                  class="border-circle h-2rem mr-3"
                  src="assets/avatar/Avatar.png"
                  alt="foto do funcionário"
                />
                {{ funcionario.nome_funcionario }}
              </div>
              <div style="width: 30%" class="normal_text">
                <div class="add_ellipsis text-center m-auto">
                  {{ funcionario.porcentagem }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="grid mt-5">
      <div class="col">
        <div class="bg-white p-5 border-round-2xl box-shadow">
          <div class="header flex">
            <span class="title"> Entrega de exames </span>
          </div>

          <div class="w-full mt-5">
            <p-accordion
              class="w-full"
              collapseIcon="pi pi-angle-up"
              expandIcon="pi pi-angle-down"
            >
              <p-accordionTab
                class="flex align-items-center border-round-xl mt-3 w-full"
                *ngFor="let item of form.value.entrega_de_exames; let i = index"
                [ngClass]="
                  i % 2 === 0
                    ? 'p-accordion-par_azul'
                    : 'p-accordion-impar_azul'
                "
              >
                <ng-template pTemplate="header">
                  <div
                    style="width: 10%"
                    class="text-left ml-3 entregaExames_primary_text"
                  >
                    {{ item.posicao_ranking }}
                  </div>

                  <div
                    style="width: 75%"
                    class="add_ellipsis flex align-items-center entregaExames_primary_text"
                  >
                    {{ item.nome_unidade }}
                  </div>

                  <div style="width: 10%">
                    <div class="text-center m-auto entregaExames_primary_text">
                      {{ item.total_entregas }}
                    </div>
                  </div>
                </ng-template>
                <ng-template pTemplate="content">
                  <div
                    class="flex align-items-center ml-3"
                    *ngFor="let funcionario of item.entregas_por_funcionario"
                  >
                    <div
                      class="entregaExames_secondary_text text-left py-2"
                      style="width: 70%"
                    >
                      {{ funcionario.nome_funcionario }}
                    </div>
                    <div
                      class="entregaExames_primary_text text-right mr-3"
                      style="width: 30%"
                    >
                      {{ funcionario.total_entregas_do_funcionario }}
                      <span class="ml-2 entregaExames_tertiary_text"
                        >exames</span
                      >
                    </div>
                  </div>
                  <div class="flex align-items-center ml-3">
                    <div
                      class="entregaExames_secondary_text text-left py-2"
                      style="width: 70%"
                    >
                      Total
                    </div>
                    <div
                      class="entregaExames_primary_text text-right mr-3"
                      style="width: 30%"
                    >
                      {{ item.total_entregas }}
                      <span class="ml-2 entregaExames_tertiary_text"
                        >exames</span
                      >
                    </div>
                  </div>
                </ng-template>
              </p-accordionTab>
            </p-accordion>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="bg-white p-5 border-round-2xl box-shadow">
          <div class="header flex">
            <span class="title"> Média resoluções enviadas </span>
          </div>

          <div class="w-full mt-5">
            <p-accordion
              class="w-full"
              collapseIcon="pi pi-angle-up"
              expandIcon="pi pi-angle-down"
            >
              <p-accordionTab
                class="flex align-items-center border-round-xl mt-3 w-full"
                *ngFor="
                  let item of form.value.media_resolucoes_enviadas;
                  let i = index
                "
                [ngClass]="
                  i % 2 === 0
                    ? 'p-accordion-par_laranja'
                    : 'p-accordion-impar_laranja'
                "
              >
                <ng-template pTemplate="header">
                  <div style="width: 10%" class="text-left ml-3 primary_text">
                    {{ item.posicao_ranking }}
                  </div>

                  <div
                    style="width: 70%"
                    class="add_ellipsis flex align-items-center primary_text"
                  >
                    {{ item.nome_unidade }}
                  </div>

                  <div style="width: 15%">
                    <div
                      class="flex justify-content-center m-auto primary_text"
                    >
                      {{ item.media_total_resolucoes }}
                      <ng-container
                        *ngIf="item.media_total_resolucoes > 1; else elseBlock"
                      >
                        dias
                      </ng-container>
                      <ng-template #elseBlock> dia </ng-template>
                    </div>
                  </div>
                </ng-template>
                <ng-template pTemplate="content">
                  <div
                    class="flex align-items-center ml-3"
                    *ngFor="let funcionario of item.resolucoes_por_funcionario"
                  >
                    <div
                      class="secondary_text text-left py-2"
                      style="width: 70%"
                    >
                      {{ funcionario.nome_funcionario }}
                    </div>
                    <div
                      class="primary_text text-right mr-3"
                      style="width: 30%"
                    >
                      {{ funcionario.qtd_resolucoes }}
                      <span class="ml-2 tertiary_text">resoluções</span>
                    </div>
                  </div>
                  <div class="flex align-items-center ml-3">
                    <div
                      class="secondary_text text-left py-2"
                      style="width: 70%"
                    >
                      Total
                    </div>
                    <div
                      class="primary_text text-right mr-3"
                      style="width: 30%"
                    >
                      {{ item.total_resolucoes }}
                      <span class="ml-2 tertiary_text">resoluções</span>
                    </div>
                  </div>
                </ng-template>
              </p-accordionTab>
            </p-accordion>
          </div>
        </div>
      </div>
    </div>

    <div class="grid mt-5">
      <div class="col">
        <div class="bg-white p-5 border-round-2xl box-shadow mb-6">
          <div class="header flex justify-content-between">
            <span class="title"> Relatório por funcionário </span>
            <div class="flex align-items-center">
              <button
                (click)="removeFilterUnidadeRelatorioFuncionario()"
                class="clear_filter mr-4"
                *ngIf="applyFilterUnidadeRelatorioFuncionario"
              >
              Limpar filtro
              </button>

              <div
                [ngClass]="
                  applyFilterUnidadeRelatorioFuncionario
                    ? 'filter-applied'
                    : 'filter'
                "
              >
                <p-menu
                  #ReportByEmployee
                  [model]="filtroUnidadeRelatorioFuncionario"
                  [popup]="true"
                ></p-menu>
                <button
                  pButton
                  type="button"
                  (click)="ReportByEmployee.toggle($event)"
                  label="Unidade"
                ></button>
              </div>
            </div>
          </div>

          <div class="mt-5 scroll_container">
            <split-report-table
              [data]="form.value.relatorio_por_funcionario"
              [total]="form.value.total_relatorio_por_funcionario"
              [widthColumns]="['7', '18', '18.75', '18.75', '18.75', '18.75']"
            >
              <ng-template #header>
                <split-icon name="arrows-down-up" class="icon"></split-icon>
              </ng-template>
              <ng-template #column let-row="row">
                <span class="second_font_style mr-3">{{
                  row?.posicao_ranking
                }}</span>
              </ng-template>

              <ng-template #header>
                <div class="text-left">Profissional</div>
              </ng-template>
              <ng-template #column let-row="row">
                <div class="text-left primary_font_style add_ellipsis">
                  {{ row?.nome_funcionario }}
                </div>
              </ng-template>

              <ng-template #header> Agendamentos feitos </ng-template>
              <ng-template #column let-row="row">{{
                row?.agendamentos_feitos
              }}</ng-template>

              <ng-template #header> Avaliações enviadas </ng-template>
              <ng-template #column let-row="row">{{
                row?.avaliacoes_enviadas
              }}</ng-template>

              <ng-template #header> Exames entregues </ng-template>
              <ng-template #column let-row="row">{{
                row?.exames_entregues
              }}</ng-template>

              <ng-template #header> Solicitações finalizadas </ng-template>
              <ng-template #column let-row="row">{{
                row?.solicitacoes_finalizadas
              }}</ng-template>
            </split-report-table>
          </div>

          <div class="mt-5 mb-5">
            <div class="header flex">
              <span class="title">Total</span>
            </div>
            <div class="mt-3">
              <div class="flex p-4 total">
                <div style="width: 7%" class="text-center seconday_font_style">
                  -
                </div>
                <div style="width: 18%" class="text-left primary_font_style">
                  Todos
                </div>
                <div style="width: 16.75%" class="text-center">
                  {{
                    form.value.total_relatorio_por_funcionario
                      ?.agendamentos_feitos
                  }}
                </div>
                <div style="width: 18.75%" class="text-center">
                  {{
                    form.value.total_relatorio_por_funcionario
                      ?.avaliacoes_enviadas
                  }}
                </div>
                <div style="width: 18.75%" class="text-center">
                  {{
                    form.value.total_relatorio_por_funcionario?.exames_entregues
                  }}
                </div>
                <div style="width: 18.75%" class="text-center">
                  {{
                    form.value.total_relatorio_por_funcionario
                      ?.solicitacoes_finalizadas
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</section>
